<template>
  <div id="app">
    <AppNavbar/>
    <!-- <Banner/> -->
    <transition name="fade-down" mode="out-in" appear>
      <router-view/>
    </transition>
    <AppFooter/>
  </div>
</template>

<script>
import AppNavbar from '@/components/AppNavbar.vue';
import AppFooter from '@/components/AppFooter.vue';

export default {
  name: 'App',
  components: {
    AppNavbar,
    AppFooter,
  },
};
</script>


<style lang="scss">
@import url(//fonts.googleapis.com/earlyaccess/notosanstc.css);

$nthu-purple: #7F1084;
$primary: $nthu-purple;
$border-hover: $nthu-purple;
$link-hover: $nthu-purple;
$link-hover-border: $nthu-purple;
$navbar-item-hover-color: $nthu-purple;
$input-hover-border-color: $nthu-purple;
$has-text-purple: $nthu-purple;
$breadcrumb-item-color: white ;
$breadcrumb-item-hover-color: LAVENDER;
$breadcrumb-item-active-color: white ;

$family-primary: "Arial", 'Noto Sans TC', BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", sans-serif;

@import "~bulma";
@import "~buefy/src/scss/buefy";

.dialog {
    .modal-card {
        .modal-card-body {
          .media-content {
            p {
              p {
                padding-bottom: 0.5rem;
              }
            }
          }
        }
    }
}

.fade-down-enter-active {
  animation-name: fadeInUp;
  animation-duration: 0.3s;
}

.fade-down-leave-active {
  animation-name: fadeOut;
  animation-duration: 0.3s;
}

@keyframes fadeInUp {
  from {
    opacity: 0.05;
    transform: translate3d(0, 25px, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
    transform: none;
  }
  to {
    opacity: 0.05;
    transform: none;
  }
}

.VueCarousel-navigation {
  .VueCarousel-navigation-prev {
    transform: translateY(-145%) translateX(-76%) !important;
  }

  .VueCarousel-navigation-next {
    transform: translateY(-145%) translateX(76%) !important;
  }
}

</style>
